import { useState, useEffect, useMemo } from 'react';

import { createAdvertisingIntegrationsList, determineConnectedAccounts, processPlatformData } from './helpers';
import { getOnsiteDataset } from '../../api/attributionReporting';
import { yesterdayTrackingQa } from '../../utils/time';
import { useGlobalState } from '../global';

export const useMissingParams = () => {
  const { segments, integrations: advertiserIntegrations, authorizations, account } = useGlobalState();
  const [missingParamsSummary, setMissingParamsSummary] = useState(undefined);

  const allPagesSegment = useMemo(() => {
    if (!segments) return null;
    return segments.find(s => s.action_type === 'segment');
  }, [segments]);

  useEffect(() => {
    if (!allPagesSegment || !authorizations || !advertiserIntegrations) return;
    const advertisingIntegrations = createAdvertisingIntegrationsList(advertiserIntegrations);
    const connectedAccounts = determineConnectedAccounts(authorizations, advertisingIntegrations);
    const hasOnsiteEventsDisabled = account.features.find(c => c === 'disable_onsite_events_tracking_qa');
    // Using this feature flag is a stopgap solution to allow the page to load if the tracking qa dataset is bloated with bad data.
    // Ideally the data should be cleaned up so the feature flag can be turned off
    if (hasOnsiteEventsDisabled) return [];
    getOnsiteDataset(allPagesSegment.action_id, 'tracking_qa_results', yesterdayTrackingQa, yesterdayTrackingQa)
      .then(resp => {
        const trackingQAData = resp?.tracking_qa_results?.[0] || {};
        Promise.all(connectedAccounts.map(platform => processPlatformData(platform, authorizations, trackingQAData)))
          .then(results => {
            const modifiedResults = results.reduce((acc, result) => ({ ...acc, ...result }), {});
            setMissingParamsSummary(modifiedResults);
          });
      });
  }, [allPagesSegment, authorizations, advertiserIntegrations]);

  return {
    missingParamsSummary,
  };
};
